type CallApiArguments = {
  query: string;
  token: string;
  endpoint: string;
  variables?: Object;
};

const [, retailUnit, language] =
  window.location.pathname.match(/\/(\w{2})\/(\w{2})\//) || [];

export default function callAPI({
  endpoint,
  token,
  query,
  variables,
}: CallApiArguments): Promise<Response> {
  return fetch(endpoint, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'Preferred-Locale': `${language.toLowerCase()}-${retailUnit.toUpperCase()}`,
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  }).then((response) => {
    if (response.status >= 400) {
      return response
        .json()
        .catch(() => '')
        .then((data) =>
          Promise.reject(
            new Error(
              `${response.statusText} (${
                response.status
              }) when contacting ${endpoint}. Response: ${JSON.stringify(data)}`
            )
          )
        );
    } else return response;
  });
}
